//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headers from '../../components/headers'
export default {
    components: {
        headers,
    },
    data () {
        return {
             model:{},
             pageModel:{},
             bannerModel:[],
             ArtModelFirst:[],
              ArtModelSecond:[],
              ArtModelThree:[],
              dataFirstTitle:"",
              dataSecondTitle:"",
              dataThreeTitle:"",
       }
    },
     created(){
        this. getIndexBanner();
        this. getPageUrlList();
        this.text();
    },
    methods: {
      open(url){
        if(url==null||url==""){
          return;
        }
        window.location.href=url;
      },
      getIndexBanner(){
        this.model.type=1;
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getIndexBanner',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                      this.bannerModel= res.body.data
                    }
                },function(res){
            });
        },
         getPageUrlList(){
            this.pageModel.pageId=1;
            this.pageModel.devPageAreaId=3;

            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getPageUrlList',this.pageModel,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                      this.ArtModelFirst= res.body.dataFirst
                      this.ArtModelSecond= res.body.dataSecond
                      this.ArtModelThree= res.body.dataThree

                      this.dataFirstTitle=res.body.dataFirstTitle
                      this.dataSecondTitle=res.body.dataSecondTitle
                      this.dataThreeTitle=res.body.dataThreeTitle

                      for(let i=0;i<this.ArtModelFirst.length;i++){
                        this.ArtModelFirst[i].addTime= this.ArtModelFirst[i].addTime.split(" ")[0]
                      }
                      for(let i=0;i<this.ArtModelSecond.length;i++){
                        this.ArtModelSecond[i].addTime= this.ArtModelSecond[i].addTime.split(" ")[0]
                      }
                      for(let i=0;i<this.ArtModelThree.length;i++){
                        this.ArtModelThree[i].addTime= this.ArtModelThree[i].addTime.split(" ")[0]
                      }

                    }
                },function(res){
            });
        },
        goList(typeId){
            if(typeId==1){
               window.location.href = "/consult/consultlist?typeId="+typeId+"&typeName="+this.dataFirstTitle
            }else if(typeId==2){
                window.location.href = "/consult/consultlist?typeId="+typeId+"&typeName="+this.dataSecondTitle
            }else{
                window.location.href = "/consult/consultlist?typeId="+typeId+"&typeName="+this.dataThreeTitle
            }
            // window.location.href = "/consult/consultlist?typeId="+typeId
        },
        goUrl(typeId,newsId){
            if(typeId==1){
                window.location.href = "/consult/consultdetail?newsId="+newsId+"&typeId="+typeId+"&typeName="+this.dataSecondTitle
            }else if(typeId==2){
               window.location.href = "/consult/consultdetail?newsId="+newsId+"&typeId="+typeId+"&typeName="+this.dataSecondTitle
            }else{
                 window.location.href = "/consult/consultdetail?newsId="+newsId+"&typeId="+typeId+"&typeName="+this.dataThreeTitle
            }
            //  window.location.href = "/consult/consultdetail?newsId="+newsId+"&typeId="+typeId
        },
        text(){
            var userAgentInfo = navigator.userAgent;
            var Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/newindex/newindex.vue